import React, { useEffect, useState } from "react";
import { classes } from "@bloomberg/media-ui-core";
import styles from "./priceDelta.module.css";

type PriceDeltaProps = {
  price: string | number;
};

const splitNumber = (previousValue: string, value: string) => {
  let constant = "";
  let delta = "";
  let direction = styles.black;

  for (let i = 0; i < value.length; i++) {
    if (previousValue[i] === value[i]) {
      constant += value[i];
    } else if (previousValue[i] < value[i]) {
      delta += value.slice(i);
      direction = styles.green;
      break;
    } else {
      delta += value.slice(i);
      direction = styles.red;
      break;
    }
  }

  return [constant, delta, direction];
};

export default function PriceDelta(props: PriceDeltaProps) {
  const { price } = props;
  const [prevPrice, setPrevPrice] = useState<string>("");
  const [constant, setConstant] = useState("");
  const [delta, setDelta] = useState("");
  const [direction, setDirection] = useState(styles.black);
  let formattedPrice = price;

  useEffect(() => {
    if (typeof formattedPrice === "number") {
      formattedPrice = price.toString();
    }
    if (formattedPrice !== prevPrice) {
      setPrevPrice(formattedPrice);
    }

    // to handle first time load so values don't flash green
    if (prevPrice.length === 0) {
      setConstant(formattedPrice);

      return;
    }

    if (prevPrice.length < formattedPrice.length) {
      setConstant("");
      setDelta(formattedPrice);
      setDirection(styles.green);
    } else if (prevPrice.length > formattedPrice.length) {
      setConstant("");
      setDelta(formattedPrice);
      setDirection(styles.red);
    } else {
      const [fixedNum, deltaNum, directionalChange] = splitNumber(
        prevPrice,
        formattedPrice
      );

      setConstant(fixedNum);
      setDelta(deltaNum);
      setDirection(directionalChange);
    }
  }, [price]);

  return (
    <div className={classes([styles.price])}>
      <span className={styles.black}>{constant}</span>
      <span
        className={direction}
        onAnimationEnd={() => {
          setDirection(styles.black);
        }}
      >
        {delta}
      </span>
    </div>
  );
}
